<span class="tiering-cutoff-hint extra-info">
  @if (showArrow()) {
    <span class="tiering-cutoff-hint-arrow">⟶</span>
  }
  @switch (hint().subject) {
    @case ('currency') { Currency }
    @case ('divCards') { Divination Cards }
    @case ('uniques') { Uniques }
  }
  {{ hint().priceLabel }}
  @if (hint().priceBaseCurrencyImage) {
    <img [src]="imgPrefix + hint().priceBaseCurrencyImage" [alt]="hint().priceBaseCurrency" class="base-type-image" />
  }
  @if (hint().subject === 'uniques') {
    will be in 'Other' tier:
    @if (hint().exampleItems.length) {
      @for (item of hint().exampleItems; track $index) {
        <span class="separated-by-comma"><span class="unique-item-color">{{ item }}</span></span>
      }
      @if (hint().hiddenCount > hint().exampleItems.length) {
        and {{ hint().hiddenCount - hint().exampleItems.length }} others
      }
    } @else {
      none
    }
  } @else {
    will be hidden:
    @if (hint().exampleItems.length) {
      @for (item of hint().exampleItems; track $index) {
        <span class="separated-by-comma"><span class="currency-color">{{ item }}</span></span>
      }
      @if (hint().hiddenCount > hint().exampleItems.length) {
        and {{ hint().hiddenCount - hint().exampleItems.length }} others
      }
    } @else {
      none
    }
  }
</span>
